export class MegaMenu {
    constructor(selector) {
        this._element = jQuery(selector);
        this.attachListeners();
    }

    attachListeners() {
        this.onWindowResize();
        this.onOpen();
        this.onClose();
    }

    onWindowResize() {
        jQuery( window ).resize(() => {
            this._element.foundation('close');
        });
    }

    onOpen() {
        this._element.on('open.zf.reveal', function() {
            jQuery("body").addClass("mega-menu-open");
        });
    }

    onClose() {
        this._element.on('closed.zf.reveal', function() {
            jQuery("body").removeClass("mega-menu-open");
        });
    }

    static setup(selector) {
        new MegaMenu(selector)
    }

}